import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HoverReplaceTextDirective } from 'src/app/directives/hover-replace-text.directive';
import { CountdownService } from 'src/app/services/countdown.service';
import { CourseCatalogService } from 'src/app/services/course-catalog.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { BidConfirmModalComponent } from './bid-confirm-modal/bid-confirm-modal.component';
import { FavoritesCalendarComponent } from './calendar/calendar.component';
import { CourseCatalogRoutingModule } from './course-catalog-routing.module';
import { ConflictTermFilterPipe, CourseCatalogComponent, GroupByFilter, WaitlistFilterPipe, TermsFilter } from './course-catalog.component';
import { CourseListComponent } from './course-list/course-list.component';
import { SectionListComponent } from './section-list/section-list.component';
import { PeopleModule } from '../people/people.module';
import { SelectSeatModalComponent } from './select-seat-modal/select-seat-modal.component';
import { BiddingDetailsComponent } from './bid-details/bidding-details.component';
import { BiddingTitleComponent } from './bid-details/bidding-title.component';



@NgModule({
    imports: [
        CommonModule,
        CourseCatalogRoutingModule,
        FormsModule,
        SharedModule,
        PeopleModule,
        NgbModule
    ],
    declarations: [
        CourseCatalogComponent,
        CourseListComponent,
        SectionListComponent,
        FavoritesCalendarComponent,
        BidConfirmModalComponent,
        WaitlistFilterPipe,        
        GroupByFilter,        
        ConflictTermFilterPipe,
        HoverReplaceTextDirective,
        SelectSeatModalComponent,
        BiddingDetailsComponent,
        BiddingTitleComponent
    ],
    providers: [
        CourseCatalogService,
        CountdownService
    ]
})
export class CourseCatalogModule { }
